import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IFontProps {
  opacityValue?: string;
  rotationValue?: string;
  fontFamilyValue?: string;
  maxHeightValue?: string;
}

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 20px 0px 20px;
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto; 
  overflow-x: hidden; 
`;

export const TopBottomSpace = styled.div`
    padding: 16px 0px 0px 0px;
`;

export const HelpText = styled.div`
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
  padding: 0px 0px 15px 0px;
`;

export const FontsContainer = styled.div`
`;

export const OEMContainer = styled.div`
  padding: 0px 0px 10px 0px;
`;

export const OEMTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const OEMTitle = styled.div`
  font-family: Roboto;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`;

export const OEMExpand = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px 10px 0px;
  cursor: pointer;
  transform: rotate(${(props: IFontProps) => (props.rotationValue ? props.rotationValue : '0')}deg);
  transition: transform 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`;

export const OEMFontsContainer = styled.div`
  max-height: ${(props: IFontProps) => (props.maxHeightValue ? props.maxHeightValue : 'auto')};
  transition: max-height 0.4s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`;

export const OEMFont = styled.div`
  width: 100%;
  height: 35px;
  border-radius: 5px;
  background-color: #cddcf1;
  display: flex;
  align-items: center;
  box-sizing: boder-box;
  cursor: pointer;
  font-size: 14px;
  overflow: hidden;
  max-height: 35px;
  transition: max-height 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    background-color: #7395c9;
    height: auto;
    min-height: 35px;
    max-height: 500px;
  }
`;

export const DragFontContainer = styled.div`
  padding: 5px 9px 5px 9px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: #FFFFFF00;
  font-family: ${(props: IFontProps) => (props.fontFamilyValue ? props.fontFamilyValue : 'Roboto')};
  color: ${C.DARK_BLUE};
  word-break: normal;
  white-space: nowrap;
  &:hover {
    word-break: break-word;
    white-space: normal;
  }
`;

export const SearchContainer = styled.div`
  width: 100%;
  height: 42px;
  display: flex;
  flex-direction: row;
  margin: 0px 0px 17px 0px;
  padding: 0px 0px 0px 0px;
  border: solid 1px rgba(130, 130, 130, 0.5);
  border-radius: 5px;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 30px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  margin: 5px 6px;
  border: none;
  outline: none;
  white-space: pre-wrap;
  align-items:center
`;

export const Message = styled.span`
    font-family: Roboto;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
    margin: 5px 0px 0px 0px;
`;

export const RemoveIconContainer = styled.div`
  margin: 8px 5px 8px 0px;
  cursor: pointer;
`;
